import { SummaryReportStateTypes, SummaryReportActionTypes } from "./SummaryReport.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: SummaryReportStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const SummaryReportReducer = (
  state: SummaryReportStateTypes = INITIAL_STATE,
  action: any
): SummaryReportStateTypes => {
  switch (action.type) {
    case SummaryReportActionTypes.FETCH_ALL_SUMMARY_REPORT:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case SummaryReportActionTypes.FETCH_ALL_SUMMARY_REPORT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case SummaryReportActionTypes.FETCH_ALL_SUMMARY_REPORT_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case SummaryReportActionTypes.FETCH_ALL_SUMMARY_REPORT_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case SummaryReportActionTypes.FETCH_ONE_SUMMARY_REPORT:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case SummaryReportActionTypes.FETCH_ONE_SUMMARY_REPORT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case SummaryReportActionTypes.FETCH_ONE_SUMMARY_REPORT_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case SummaryReportActionTypes.FETCH_ONE_SUMMARY_REPORT_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default SummaryReportReducer;
